import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { browserPushUrl } from '@/utils';
import { GlobalTracker } from '@/utils/Tracker';
import styles from './index.module.less';
import dynamic from 'next/dynamic';
import cls from 'classnames';
import { CartUsePositions } from '@/mobx/meta';

const PopCartList = dynamic(import('./PopCartList'), { ssr: false });
const CartIconBadge = dynamic(import('./components/CartIconBadge'), { ssr: false });

@inject('area', 'order', 'meta', 'app')
@observer
class Cart extends Component {
  loadedCartDetail = false;

  handleLoadCartDetail = () => {
    const { isOrderConfirmPage, isCartPage } = this.props.app;
    if (isOrderConfirmPage || isCartPage) return;

    if (this.loadedCartDetail) return;
    this.loadedCartDetail = true;
    this.props.order.loadAllCartDetail();
  };

  onClickBtn = () => {
    GlobalTracker.navigation({ action: 'click_cart' });
    browserPushUrl('/cart?from=nav');
  };

  render() {
    const { popupCartListVisible, navCurStyle, currentActiveCartPosition } = this.props.meta;
    const {
      order: { ShoppingCartAllItems },
      isDarkBg = false,
      cartIcon,
      customCartStyle,
      popupProductListClassName,
      customBtnClassName,
      popupClassName,
      position = CartUsePositions.navBar,
    } = this.props;
    let cartItemsCount = 0;

    // 判断cart模块是否为激活
    const showPopupList = currentActiveCartPosition === position;

    ShoppingCartAllItems.forEach((o) => {
      cartItemsCount += o.count || 0;
    });
    // 弹窗展示的时候也调用加载方法
    if (popupCartListVisible) {
      this.handleLoadCartDetail();
    }

    return (
      <div className={cls(styles.Cart, customCartStyle)} ref={this.cartRef}>
        <button
          className={cls(styles.btn, customBtnClassName)}
          style={{
            backgroundImage: `url('${
              cartIcon ??
              (!isDarkBg
                ? navCurStyle?.cartIcon
                : 'https://res.insta360.com/static/2b70b18ff0a52c944878ed63c5be3a5b/Frame%20626873257.svg')
            }')`,
            width: 48,
            height: 48,
          }}
          onMouseEnter={this.handleLoadCartDetail}
          onClick={this.onClickBtn}
        >
          <CartIconBadge count={cartItemsCount} />
        </button>
        {showPopupList && (
          <PopCartList
            isDarkBg={isDarkBg}
            containerClassName={popupProductListClassName}
            popupClassName={popupClassName}
          />
        )}
      </div>
    );
  }
}

export default Cart;
